import { createAction } from "redux-actions";

import {
    APP_LEGACY_LOADED,
    APP_MENU_STATE,
    APP_SIDE_PANEL_TOGGLE,
    APP_VIEWPORT,
    PAGE_LEAVE,
    APP_LOGIN_DIALOG_SHOW,
    APP_WORKING_ORDER_TOGGLE,
} from "constants/action-types";

// ACTIONS
export const pageLeave = createAction(PAGE_LEAVE);

export const legacyLoaded = createAction(APP_LEGACY_LOADED);

export const setViewport = (viewport: "hd" | "desktop" | "tablet" | "phablet" | "mobile") => {
    return {
        type: APP_VIEWPORT,
        payload: viewport,
    };
};

export const updateNavState = (state: "icon" | "hover" | "pinned") => {
    return {
        type: APP_MENU_STATE,
        payload: state,
    };
};

export const toggleSidePanel = (open: boolean) => {
    return {
        type: APP_SIDE_PANEL_TOGGLE,
        payload: open,
    };
};

export const toggleLoginDialog = (open: boolean, redirect: string) => {
    return {
        type: APP_LOGIN_DIALOG_SHOW,
        open,
        redirect,
    };
};

export const toggleWorkingOrderLoadingDialog = (open: boolean) => {
    return {
        type: APP_WORKING_ORDER_TOGGLE,
        open,
    };
};
